module.exports = "/_next/static/festival-gw.5369a1c0a29caae4bb18779490cde35c.css";